"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.soundReducer = soundReducer;
var _types = require("./types");
var _reducer = require("./reducer");
function soundReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _reducer.initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types.SOUND_CREATE_SPRITE:
      {
        switch (action.payload.sound) {
          case _types.SoundPack.Voice:
          case _types.SoundPack.Voice2:
          case _types.SoundPack.Voice3:
          case _types.SoundPack.Voice4:
          case _types.SoundPack.Voice5:
            {
              var newState = Object.assign({}, state);
              var keys = Object.keys(action.payload.sprite);
              for (var index = 0; index < keys.length; index++) {
                var name = keys[index];
                var split = name.split("_");
                if (!newState.voices[split[0]]) newState.voices[split[0]] = [];
                if (!newState.voices[split[0]][split[1]]) newState.voices[split[0]][split[1]] = [];
                newState.voices[split[0]][split[1]].push(name);
              }
              return newState;
            }
        }
        return state;
      }
    case _types.SOUND_UNLOCKED:
      {
        return Object.assign({}, state, {
          unlocked: true
        });
      }
    case _types.SOUND_TOGGLE_DEBUG:
      {
        return Object.assign({}, state, {
          debug: !state.debug
        });
      }
    case _types.SOUND_PLAY_RATE:
    case _types.SOUND_STOP:
    case _types.SOUND_FADE:
    case _types.SOUND_PLAY:
      {
        var _action$payload$volum;
        // console.log('SOUND COMMAND CHANGE')
        // console.log(action)

        var _newState = Object.assign({}, state);
        if (!_newState.soundStates[action.payload.sound]) _newState.soundStates[action.payload.sound] = {};
        if (!_newState.soundStates[action.payload.sound][action.payload.spriteId]) _newState.soundStates[action.payload.sound][action.payload.spriteId] = {};
        _newState.soundStates[action.payload.sound][action.payload.spriteId].volume = (_action$payload$volum = action.payload.volume) !== null && _action$payload$volum !== void 0 ? _action$payload$volum : action.payload.to;

        //   console.log(newState.soundStates)

        return _newState;
      }
    default:
      return state;
  }
}
//# sourceMappingURL=soundReducer.js.map